import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { getRelativeRoute } from '@/router/routes';

type NavigateTo =
  | 'GRADING_CASE_STEP_1'
  | 'GRADING_CASE_STEP_2'
  | 'GRADING_CASE_STEP_3'
  | 'GRADING_CASE_STEP_4';

type NavigateToInsights = 'INSIGHTS_DR_FORM_STEP_1' | 'INSIGHTS_DR_FORM_STEP_2';

export function useNavigateFlow() {
  const navigate = useNavigate();

  const navigateFlow = useCallback(
    (to: NavigateTo | NavigateToInsights) => {
      navigate(`../${getRelativeRoute(to)}`);
    },
    [navigate]
  );

  return {
    navigateFlow,
  };
}
